import React from 'react'
 import img from '../../images/vision.jpg'

const Vision = () => {

    return (
        <article className="eidefut-vision">
          <h1>Visión</h1>
          <img src={img}
          className="cover" alt="Eidefut"/>
          <p className="mt-5 lh-copy text-center">
            La asociación deportiva “EIDEFUT”, David Pinto  fundada el año 2015, tiene como 
            actividad principal la del entrenamiento  y adiestramiento deportivo, 
            especialmente en la disciplina del futbol sala. Desde que comenzó hasta 
            hoy brinda clases magistrales a jóvenes  y niños atletas en edades comprendidas
             desde los 4 a 16 años de edad. Divididos por categorías de acuerdo a su edad, 
             catalogados por año de nacimiento. Las clases y entrenamiento que reciben los 
             jóvenes atletas son de alto nivel y calidad profesional, ya que dichas clases 
             son dictadas por profesores y atletas de amplia trayectoria entre ellos 
             Nuestra Gloria Deportiva David Pinto y campeón Mundial de Futbol Sala en México 1997,  
             escuela que lleva su nombre  Escuela de Iniciación Deportiva de Futbol 
             Sala EIDEFUT “DAVID PINTO”.

          </p>
          <p className="lh-copy text-center">
            El objetivo de esta escuela, es social, económico, cultural-recreacional, 
            pero principalmente preparar la mayor cantidad de  semilleros del jugadores de 
            Futbol Sala  y hombre y mujeres centrados y de éxito en todos los aspectos de su vida. 
            En nuestra escuela también atendemos a las jóvenes y niñas que sientan pasión por este 
            deporte y con talento, que sean  de bajos recursos que no pueden pagar una mensualidad 
            son exonerados de dicho pago, pero igualmente pagan con responsabilidad, disciplina y 
            comportamiento. Actualmente tenemos 15 niños exonerados del pago.
            En este sentido la escuela de Futbol Sala “DAVID PINTO” viene a ser una alternativa de 
            gran impacto positivo en la contribución con la juventud y el deporte del municipio y de 
            todo nuestro país, ya que iniciativas como estas pueden repetirse en cada localidad.

          </p> 
          <p className="lh-copy text-center">
            Es además una ayuda excelente para los padres que quieren orientar a sus pequeños en 
            una disciplina deportiva, de manos de expertos y apasionados de este deporte.
            Además de ello la cancha Raúl Albert donde funciona esta escuela, sirve de apoyo para 
            eventos más representativos del Municipio, sirve de apoyo a escuelas y empresas que 
            quieren brindar a sus trabajadores una opción de esparcimiento y recreación.
            Esta cancha bien acondicionada pudiera servir  para activar en el municipio el 
            TURISMO DEPORTIVO, ya que por su localización excelente nos permitiría tener 
            actividades durante todo el año, y atender más niños. 
          </p>
        </article>
        );
      }
export default Vision;